// Lucide icon: chevron-up (https://lucide.dev/icons/chevron-up)
import { ChevronUp } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconChevronUp = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ChevronUp />
    </IconComponentStyled>
  )
}
